// import "./datatable.scss";
// import { DataGrid, GridToolbar } from "@mui/x-data-grid";
// import { sawardlistColumns } from "../../datatablesource";
// import { Link } from "react-router-dom";
// import { useState, useEffect } from "react";
// import { useSlug } from "../../SlugContext";
// import { serverUrl } from "../../temp";
// import AddNumberModal from "../modal component/modal_component";
// import { toast } from "react-toastify";
// import Loader from "../loader/Loader";

// const SAwardlistDataTable = () => {
//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [selectedStudent, setSelectedStudent] = useState(null);
//   const [modalOpen, setModalOpen] = useState(false);
//   const [studentsWithNumbers, setStudentsWithNumbers] = useState([]);
//   const { slugs } = useSlug();

//   // Get required IDs from localStorage
//   const Subject = localStorage.getItem("subject_name_for_awardlist");
//   const examination_id = localStorage.getItem("examination_id");
//   const center_id = localStorage.getItem("center_id");
//   const subject_id = localStorage.getItem("subject_id_for_awardlist");

//   const fetchStudents = async () => {
//     setLoading(true);
//     try {
//       const response = await fetch(
//         `${serverUrl}/get_awardlist_students?examination_id=${examination_id}&center_id=${center_id}&subject_id=${subject_id}`
//       );
//       const data = await response.json();

//       if (data.status === "true") {
//         setData(data.data);
//         // Fetch students with numbers after getting award list students
//         await fetchStudentsWithNumbers();
//       } else {
//         setData([]);
//         toast.error(data.message || "No students found");
//       }
//     } catch (error) {
//       console.error("Error fetching students:", error);
//       toast.error("Failed to load students");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchStudentsWithNumbers = async () => {
//     try {
//       const response = await fetch(
//         `${serverUrl}/get_students_with_numbers?examination_id=${examination_id}&center_id=${center_id}`
//       );
//       const result = await response.json();

//       if (result.status === "true") {
//         setStudentsWithNumbers(result.data);
//       } else {
//         setStudentsWithNumbers([]);
//       }
//     } catch (error) {
//       console.error("Error fetching students with numbers:", error);
//       setStudentsWithNumbers([]);
//     }
//   };

//   useEffect(() => {
//     fetchStudents();
//   }, [examination_id, center_id, subject_id]);

//   const handleAddNumber = (student) => {
//     setSelectedStudent(student);
//     setModalOpen(true);
//     localStorage.setItem("student_id_n", student.id);
//     localStorage.setItem("student_name_n", student.name);
//   };

//   const handleCloseModal = (updated = false) => {
//     setModalOpen(false);
//     if (updated) {
//       fetchStudents(); // Refresh the list after update
//     }
//   };

//   const actionColumn = [
//     {
//       field: "action",
//       headerName: "Action",
//       width: 200,
//       renderCell: (params) => {
//         const hasNumber = studentsWithNumbers.includes(params.row.id);

//         return (
//           <div className="cellAction">
//             {slugs && slugs.includes("Awardlist-Addnumber") && (
//               <button
//                 className={hasNumber ? "updateButton" : "addButton"}
//                 onClick={() => handleAddNumber(params.row)}
//               >
//                 {hasNumber ? "🔄 Update Number" : "➕ Add Number"}
//               </button>
//             )}
//           </div>
//         );
//       },
//     },
//   ];

//   return (
//     <div className="datatable">
//       <div className="datatableTitle">
//         {Subject} AwardList
//         <div className="linkGroup">
//           <Link to="/examinations" className="commonButton w-full sm:w-auto">
//             Back
//           </Link>
//         </div>
//       </div>

//       {loading ? (
//         <Loader fullScreen={false} />
//       ) : data.length === 0 ? (
//         <div className="noStudents">No students found for this subject</div>
//       ) : (
//         <DataGrid
//           className="datagrid"
//           rows={data}
//           columns={sawardlistColumns.concat(actionColumn)}
//           pageSize={9}
//           rowsPerPageOptions={[9]}
//           components={{
//             Toolbar: GridToolbar,
//           }}
//           getRowId={(row) => row.id}
//         />
//       )}

//       {modalOpen && selectedStudent && (
//         <AddNumberModal
//           open={modalOpen}
//           onClose={handleCloseModal}
//           student={selectedStudent}
//           examination_id={examination_id}
//           center_id={center_id}
//         />
//       )}
//     </div>
//   );
// };

// export default SAwardlistDataTable;

import { DataGrid } from "@mui/x-data-grid";
import { Link } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import { useSlug } from "../../SlugContext";
import { serverUrl } from "../../temp";
import { toast } from "react-toastify";
import Loader from "../loader/Loader";
import {
  Button,
  Box,
  Chip,
  useMediaQuery,
  useTheme,
  Typography,
  Card,
  CardContent,
  TextField,
  InputAdornment,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const SAwardlistDataTable = () => {
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [editedRows, setEditedRows] = useState({});
  const { slugs } = useSlug();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const inputRefs = useRef({});

  // Get required IDs from localStorage
  const Subject = localStorage.getItem("subject_name_for_awardlist");
  const examination_id = localStorage.getItem("examination_id");
  const center_id = localStorage.getItem("center_id");
  const class_id = localStorage.getItem("Aclass_id");
  const subject_id = localStorage.getItem("subject_id_for_awardlist");
  const total_marks = parseInt(localStorage.getItem("total_marks"), 10) || 100;

  const fetchStudentsWithResults = async () => {
    setLoading(true);
    try {
      // Fetch basic student list
      const studentsResponse = await fetch(
        `${serverUrl}/get_awardlist_students?examination_id=${examination_id}&center_id=${center_id}&subject_id=${subject_id}&class_id=${class_id}`
      );
      const studentsData = await studentsResponse.json();

      if (studentsData.status !== "true" || !studentsData.data) {
        setStudents([]);
        toast.error(studentsData.message || "No students found");
        return;
      }

      // Fetch existing results for these students
      let resultsData = { status: "false", data: [] };
      try {
        const resultsResponse = await fetch(
          `${serverUrl}/get_student_results_bulk?examination_id=${examination_id}&center_id=${center_id}&subject_id=${subject_id}`
        );
        resultsData = await resultsResponse.json();
      } catch (error) {
        console.warn("Could not fetch existing results:", error);
        // Continue with empty results data
      }

      // Combine student data with results
      const combinedData = studentsData.data.map((student) => {
        const result =
          resultsData.status === "true" && resultsData.data
            ? resultsData.data.find((r) => r.student_id === student.id)
            : null;

        return {
          ...student,
          obtain_number: result?.obtain_number || "",
          grade: result?.grade || "",
          remarks: result?.remarks || "",
          percentage: result?.percentage || 0,
          result_id: result?.id || null,
          hasExistingResult: !!result,
        };
      });

      setStudents(combinedData);
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("Failed to load student data");
      setStudents([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStudentsWithResults();
  }, [examination_id, center_id, subject_id]);

  const handleNumberChange = (studentId, value) => {
    // Validate input
    const numValue = parseFloat(value);
    if (
      value !== "" &&
      (isNaN(numValue) || numValue < 0 || numValue > total_marks)
    ) {
      toast.error(`Marks must be between 0 and ${total_marks}`);
      return;
    }

    setEditedRows((prev) => ({
      ...prev,
      [studentId]: {
        ...prev[studentId],
        obtain_number: value === "" ? "" : numValue,
      },
    }));
  };

  const focusNextInput = (currentIndex) => {
    const nextIndex = currentIndex + 1;
    if (nextIndex < students.length && inputRefs.current[nextIndex]) {
      inputRefs.current[nextIndex].focus();
    }
  };

  const calculateGradeAndRemarks = (obtainNumber) => {
    if (obtainNumber === "" || obtainNumber === null || isNaN(obtainNumber)) {
      return { grade: "", remarks: "", percentage: 0 };
    }

    const percentage = (obtainNumber / total_marks) * 100;
    if (percentage >= 90)
      return { grade: "A+", remarks: "Marvelous", percentage };
    if (percentage >= 80)
      return { grade: "A+", remarks: "Excellent", percentage };
    if (percentage >= 70)
      return { grade: "A", remarks: "Very Good", percentage };
    if (percentage >= 60) return { grade: "B", remarks: "Fair", percentage };
    if (percentage >= 50) return { grade: "C", remarks: "Average", percentage };
    return { grade: "D", remarks: "Need Improvement", percentage };
  };

  const handleSaveAll = async () => {
    setSaving(true);
    try {
      const updates = Object.entries(editedRows)
        .map(([studentId, data]) => {
          const student = students.find((s) => s.id === parseInt(studentId));
          const { grade, remarks, percentage } = calculateGradeAndRemarks(
            data.obtain_number
          );

          return {
            student_id: parseInt(studentId),
            obtain_number: data.obtain_number,
            grade,
            remarks,
            percentage,
            result_id: student?.result_id || null,
            has_existing_result: student?.hasExistingResult || false,
          };
        })
        .filter(
          (update) =>
            update.obtain_number !== "" && update.obtain_number !== null
        );

      if (updates.length === 0) {
        toast.info("No changes to save");
        setSaving(false);
        return;
      }

      const response = await fetch(`${serverUrl}/bulk_update_awardlist`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          updates,
          examination_id: parseInt(examination_id),
          center_id: parseInt(center_id),
          subject_id: parseInt(subject_id),
          user_id: parseInt(localStorage.getItem("user_id") || 0),
        }),
      });

      const result = await response.json();
      if (result.status === "true") {
        toast.success(
          `Saved ${result.updated_count || updates.length} marks successfully!`
        );
        setEditedRows({});
        fetchStudentsWithResults();
      } else {
        throw new Error(result.message || "Failed to save marks");
      }
    } catch (error) {
      console.error("Error saving marks:", error);
      toast.error(error.message || "Failed to save marks");
    } finally {
      setSaving(false);
    }
  };

  // Mobile Card View with inline input fields
  const renderMobileCards = () => {
    return students.map((student, index) => {
      const editedValue = editedRows[student.id]?.obtain_number;
      const displayValue =
        editedValue !== undefined ? editedValue : student.obtain_number;
      const { grade, remarks } = calculateGradeAndRemarks(displayValue);

      // Color mapping for grades
      const gradeColors = {
        "A+": "text-green-700 bg-green-100",
        A: "text-green-600 bg-green-100",
        B: "text-yellow-700 bg-yellow-100",
        C: "text-orange-700 bg-orange-100",
        D: "text-red-700 bg-red-100",
        "": "text-gray-500 bg-gray-100",
      };

      const statusColors = {
        saved: "text-green-700 bg-green-100 border-green-300",
        unsaved: "text-yellow-700 bg-yellow-100 border-yellow-300",
        pending: "text-gray-500 bg-gray-100 border-gray-300",
      };

      const status =
        student.hasExistingResult && !editedRows[student.id]
          ? "saved"
          : editedRows[student.id]
          ? "unsaved"
          : "pending";

      return (
        <div
          key={student.id}
          className="mb-4 p-4 bg-white rounded-lg shadow-md border border-gray-200"
        >
          {/* Student Info */}
          <div className="mb-3">
            <h3 className="text-lg font-semibold text-gray-800">
              {student.name}
            </h3>
            <p className="text-sm text-gray-600">
              Roll No: {student.roll_number} | Class: {student.class_name}
            </p>
          </div>

          {/* Marks Input Field */}
          <div className="mb-3">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Marks (Max: {total_marks})
            </label>
            <div className="relative">
              <input
                type="number"
                value={displayValue}
                onChange={(e) => handleNumberChange(student.id, e.target.value)}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    focusNextInput(index);
                  }
                }}
                ref={(el) => (inputRefs.current[index] = el)}
                min="0"
                max={total_marks}
                step="0.01"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                placeholder="Enter marks"
              />
              <span className="absolute right-3 top-2 text-sm text-gray-500">
                /{total_marks}
              </span>
            </div>
          </div>

          {/* Grade and Status */}
          <div className="flex justify-between items-center">
            <div>
              <p className="text-xs text-gray-600">Grade</p>
              <span
                className={`inline-block px-2 py-1 rounded text-sm font-semibold ${
                  gradeColors[grade] || gradeColors[""]
                }`}
              >
                {grade || "-"}
              </span>
            </div>

            <div>
              <p className="text-xs text-gray-600">Status</p>
              <span
                className={`inline-block px-2 py-1 rounded text-xs border ${statusColors[status]}`}
              >
                {status === "saved"
                  ? "Saved"
                  : status === "unsaved"
                  ? "Unsaved"
                  : "Pending"}
              </span>
            </div>
          </div>

          {/* Remarks */}
          {remarks && (
            <div className="mt-2">
              <p className="text-sm text-gray-600 italic">Remarks: {remarks}</p>
            </div>
          )}
        </div>
      );
    });
  };

  // Desktop DataGrid Columns
  const columns = [
    {
      field: "roll_number",
      headerName: "Roll No",
      width: 100,
      headerClassName: "font-bold bg-gray-100",
    },
    {
      field: "name",
      headerName: "Student Name",
      width: 200,
      headerClassName: "font-bold bg-gray-100",
    },
    {
      field: "class_name",
      headerName: "Class",
      width: 120,
      headerClassName: "font-bold bg-gray-100",
    },
    {
      field: "obtain_number",
      headerName: `Obtained Marks / ${total_marks}`,
      width: 180,
      headerClassName: "font-bold bg-gray-100",
      renderCell: (params) => {
        const editedValue = editedRows[params.row.id]?.obtain_number;
        const displayValue =
          editedValue !== undefined ? editedValue : params.row.obtain_number;

        return (
          <div className="w-full flex flex-col gap-1">
            <input
              type="number"
              value={displayValue}
              onChange={(e) =>
                handleNumberChange(params.row.id, e.target.value)
              }
              min="0"
              max={total_marks}
              step="0.01"
              className="w-full px-2 py-1 border border-gray-300 rounded text-sm focus:outline-none focus:ring-1 focus:ring-purple-500"
            />
            {params.row.hasExistingResult && !editedRows[params.row.id] && (
              <span className="text-xs text-green-700 bg-green-100 px-1 rounded self-start">
                Saved
              </span>
            )}
          </div>
        );
      },
    },
    {
      field: "grade",
      headerName: "Grade",
      width: 100,
      headerClassName: "font-bold bg-gray-100",
      renderCell: (params) => {
        const editedValue = editedRows[params.row.id]?.obtain_number;
        const displayValue =
          editedValue !== undefined ? editedValue : params.row.obtain_number;
        const { grade } = calculateGradeAndRemarks(displayValue);

        const gradeColors = {
          "A+": "text-green-700 font-bold",
          A: "text-green-600 font-bold",
          B: "text-yellow-700 font-bold",
          C: "text-orange-700 font-bold",
          D: "text-red-700 font-bold",
        };

        return (
          <span className={gradeColors[grade] || "text-gray-700"}>{grade}</span>
        );
      },
    },
    {
      field: "remarks",
      headerName: "Remarks",
      width: 150,
      headerClassName: "font-bold bg-gray-100",
      renderCell: (params) => {
        const editedValue = editedRows[params.row.id]?.obtain_number;
        const displayValue =
          editedValue !== undefined ? editedValue : params.row.obtain_number;
        const { remarks } = calculateGradeAndRemarks(displayValue);

        return <span className="text-sm italic text-gray-600">{remarks}</span>;
      },
    },
  ];

  const hasEdits = Object.keys(editedRows).length > 0;
  const studentsWithMarks = students.filter(
    (s) => s.obtain_number !== ""
  ).length;

  return (
    <div className="min-h-screen p-5 bg-white-50">
      {/* Header Section */}
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-6">
        <h1 className="text-2xl md:text-3xl font-bold text-purple-700">
          {Subject} Award List
        </h1>

        <div className="flex flex-col md:flex-row gap-3 w-full md:w-auto">
          <div className="flex items-center gap-2 order-2 md:order-1">
            <span className="text-sm text-gray-600">
              {studentsWithMarks} of {students.length} students have marks
            </span>
          </div>

          <div className="flex flex-col sm:flex-row gap-2 order-1 md:order-2">
            {hasEdits && (
              <button
                onClick={handleSaveAll}
                disabled={saving}
                className="flex items-center justify-center gap-1 px-4 py-2 bg-purple-100 text-purple-700 border border-purple-300 rounded-md hover:bg-purple-200 transition-colors disabled:opacity-50"
              >
                <SaveIcon className="w-4 h-4" />
                {saving
                  ? "Saving..."
                  : `Save Changes (${Object.keys(editedRows).length})`}
              </button>
            )}

            <Link
              to="/examinations"
              className="flex items-center justify-center gap-1 px-4 py-2 border border-green-500 text-green-600 rounded-md hover:bg-green-500 hover:text-white transition-colors text-center"
            >
              <ArrowBackIcon className="w-4 h-4" />
              Back to Exams
            </Link>
          </div>
        </div>
      </div>

      {/* Stats Summary */}
      <div className="flex flex-wrap gap-3 mb-6 justify-center md:justify-start">
        <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200 text-center min-w-[100px]">
          <p className="text-xl font-semibold text-purple-700">
            {students.length}
          </p>
          <p className="text-sm text-gray-600">Total</p>
        </div>

        <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200 text-center min-w-[100px]">
          <p className="text-xl font-semibold text-green-600">
            {studentsWithMarks}
          </p>
          <p className="text-sm text-gray-600">Entered</p>
        </div>

        <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200 text-center min-w-[100px]">
          <p className="text-xl font-semibold text-yellow-600">
            {students.length - studentsWithMarks}
          </p>
          <p className="text-sm text-gray-600">Pending</p>
        </div>

        {hasEdits && (
          <div className="bg-white p-4 rounded-lg shadow-sm border border-yellow-300 text-center min-w-[100px]">
            <p className="text-xl font-semibold text-yellow-700">
              {Object.keys(editedRows).length}
            </p>
            <p className="text-sm text-gray-600">Unsaved</p>
          </div>
        )}
      </div>

      {/* Mobile Instructions */}
      {isMobile && (
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 mb-4 mx-2">
          <p className="text-sm font-semibold text-blue-800">
            💡 Quick Entry Tip:
          </p>
          <p className="text-sm text-blue-700">
            Press Enter after entering marks to jump to the next student. Tap
            "Save All Changes" when finished.
          </p>
        </div>
      )}

      {/* Content */}
      {loading ? (
        <div className="flex justify-center items-center min-h-[300px]">
          <Loader fullScreen={false} />
        </div>
      ) : students.length === 0 ? (
        <div className="flex flex-col justify-center items-center min-h-[300px] text-center p-6">
          <h3 className="text-lg text-gray-600 mb-2">
            No students found for this subject
          </h3>
          <p className="text-sm text-gray-500">
            Please check if the selected examination and subject have enrolled
            students.
          </p>
        </div>
      ) : isMobile ? (
        // Mobile Card View with inline inputs
        <div className="p-1">{renderMobileCards()}</div>
      ) : (
        // Desktop DataGrid View
        <div className="h-[600px] w-full bg-white rounded-lg shadow-sm border border-gray-200">
          <DataGrid
            rows={students}
            columns={columns}
            getRowId={(row) => row.id}
            disableSelectionOnClick
            pagination={false} // Disable pagination
            sx={{
              border: "none",
              "& .MuiDataGrid-cell:focus": {
                outline: "none",
              },
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#f8fafc",
              },
            }}
          />
        </div>
      )}
    </div>
  );
};

export default SAwardlistDataTable;
